import isEmpty from 'lodash/isEmpty';
import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import {
  WIRFinalWIRSections,
  WIRInterventionCloseOutSections,
  WIRKofMeetingTechnicalWirSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

export const getSectionSavingDisabled = (wir: WIR | null, section: string) => {
  switch (section) {
    case WIRKofMeetingTechnicalWirSections.signOffTechnicalWIR:
      return (
        !isEmpty(wir?.signOffs?.technicalWirOriginator?.userId) &&
        !isEmpty(wir?.signOffs?.technicalWirAssetRep?.userId) &&
        !isEmpty(wir?.signOffs?.technicalWirInterventionEngineer?.userId)
      );
    case WIRFinalWIRSections.finalWirSignOff:
      return getIsUnplannedReactiveScope(wir)
        ? !isEmpty(wir?.signOffs?.finalWirAssetManager?.userId) &&
            !isEmpty(wir?.signOffs?.finalWirWscLeader?.userId)
        : !isEmpty(wir?.signOffs?.finalWirAssetManager?.userId) &&
            !isEmpty(wir?.signOffs?.finalWirGsrManager?.userId) &&
            !isEmpty(wir?.signOffs?.finalWirPerformanceLead?.userId) &&
            !isEmpty(wir?.signOffs?.finalWirWscLeader?.userId) &&
            !isEmpty(wir?.signOffs?.finalWirSiteSupportLeader?.userId) &&
            !isEmpty(wir?.signOffs?.finalWirHeadOfReservoir?.userId);
    case WIRInterventionCloseOutSections.hqTechnicalfinalInterventionSignOff:
      return !isEmpty(wir?.signOffs?.interventionCloseOutFinalSignOff?.userId);
    default:
      return false;
  }
};
